module.exports = __webpack_public_path__ + "static/lantern-of-revealing-mtg_CLB-3d61862342b31e03c90e09f6d1b23167.webp";